import React from 'react';
import AddFundsCardPaymentProvider1 from '../features/AddFundsCardPaymentProvider1';
import ScreenWrapper from '../features/Theme/ScreenWrapper';

type Props = {
    paymentProvider1Method?: string;
    currentAmount?: string;
    setActiveRightTab?: Function;
    paymentProvider1Currency?: string;
};

export default function AddFundsCardPaymentProvider1Screen({
    paymentProvider1Method,
    currentAmount,
    setActiveRightTab,
    paymentProvider1Currency,
}: Props) {
    return (
        <ScreenWrapper>
            <AddFundsCardPaymentProvider1
                paymentProvider1Method={paymentProvider1Method}
                currentAmount={currentAmount}
                setActiveRightTab={setActiveRightTab}
                paymentProvider1Currency={paymentProvider1Currency}
            />
        </ScreenWrapper>
    );
}
